// ConfirmDialog.js
import React from "react";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  StyledButton,
  theme,
} from "../../pages/doctor-console/StyledComponents";
import { ThemeProvider } from "@mui/material/styles";
import "./ShowConfirmDialog.scss"

const ConfirmDialog = ({ message, onConfirm, onCancel }) => {
  return (
    <ThemeProvider theme={theme}>
      <p dangerouslySetInnerHTML={{ __html: message }} />
      <div style={{ display: "flex", justifyContent: "flex-end", gap: "10px", marginTop: "12px" }}>
        <button onClick={onConfirm} className="button button-contained">
          Ok
        </button>
        <button onClick={onCancel} className="button button-contained-cancel">
          Cancel
        </button>
      </div>
    </ThemeProvider>
  );
};

const showConfirmDialog = (message) => {
  return new Promise((resolve) => {
    const onConfirm = () => {
      resolve(true);
      toast.dismiss();
    };

    const onCancel = () => {
      resolve(false);
      toast.dismiss();
    };

    toast(
      <ThemeProvider theme={theme}>
        <ConfirmDialog
          message={message}
          onConfirm={onConfirm}
          onCancel={onCancel}
        />
      </ThemeProvider>,
      {
        autoClose: false,
      }
    );
  });
};

export default showConfirmDialog;
